//  // size-cart-code-custom
//   function sizeguide(){
//     document.querySelectorAll('.cstmSize .product-popup-modal__button').forEach(sizeguidebtn => {
     
//           const sizechartTags = sizeguidebtn.getAttribute('data-apne-product-tags');
//           const shopURL = sizeguidebtn.getAttribute('data-apna-shop-name');
//           const productId = sizeguidebtn.getAttribute('pro-id');
//           const backend_url = 'https://sizechart-revamp-be.alche.cloud';
          
//              const api_URL_sizeChart = '/ajax_call_sizechart?shop=' + shopURL + '&tags=';
//              let sizeChart_url = backend_url + api_URL_sizeChart + sizechartTags.replace(/&/g, "&amp;");
          
  
//           fetch(sizeChart_url)
//          .then((response) => {
//            return response.json()
//          })
//           .then((data) => {
              
//                let raw_html = ''
//                const first_index_to_show = 0
//                const size_attributes = {}
//                var size_data ='';
//                var sizes = new Array();
//                var random = '';
//                const topDes = data.size_chart.top_description
//                const { grid_sizechart } = data.size_chart
//                const { sizechart_type } = data.size_chart
  
//          grid_sizechart.forEach(attr => {
//            const list = attr;
//            const keyAttr = list.shift();
//            size_attributes[keyAttr] = list;
//          });
//           raw_html += `<div title="${sizechart_type}" tag="${sizechart_type}" class="size-chart-content-wrapper">`
//          raw_html += '<div class="size-chart-main-content">'
//          raw_html += '<div class = "size-chart-content-data">'
//          raw_html += '<div class="size-chart-title"><h2>Size help</h2><p class="size-chart-subheading">Select size</p></div>'
         
//          raw_html += '<div class = "size-chart-content-show tab">'
//          size_attributes['SIZE'].map((elem, index) =>{
           
//            raw_html += `<div class="size-chart-size-variant tablinks ">${elem}</div>`
//          })
//          raw_html += '</div>'
         
//          raw_html += '<div class="top-desc">' +topDes + '</div>'
         
//          raw_html += '<div class="size-chart-head"><p class="head">MEASUREMENTS</p><p class="head right-align">CM</p><p class="head right-align">INCH</p></div>'
//          size_attributes['SIZE'].map((elem, index) =>{
//            raw_html += `<div id="${elem}" class="size-chart-table tabcontent"">`
           
//            Object.keys(size_attributes).map(key =>{
//              if (key == 'SIZE'){ return }
//              const record = size_attributes[key]
//              const cm_inch = Math.ceil(record[index]*0.393701);
//              raw_html += '<div class="size-chart-size-data">'
//              raw_html += `<div class="size-data-bold">${key}</div>`
//              raw_html += `<div class="size-data-bold right-align">${record[index]}</div>`
//              raw_html += `<div class="size-data-bold right-align">${cm_inch}</div>`
//              raw_html += '</div>'	
//              })
//            raw_html += '</div>'
//          })
//          raw_html += '</div>'
//          raw_html += `<div class="size-chart-content-img"><img class="image" src='${data.size_chart.bottom_description}' loading="lazy"></div>
//          </div>
//          <div class="size-note">Note: The size help refers to the product measurements which may slightly vary according to design.</div>
//          </div>`
//         document.querySelector(`#size-chart-main-id-${productId}`).innerHTML = raw_html;
//        // document.querySelector(`#PopupModal-size-guide-${productId}`).setAttribute('open', '');
//         // if (size_attributes && size_attributes['SIZE'] && size_attributes['SIZE'].length > 0) {
//            openCity(undefined, size_attributes['SIZE'][first_index_to_show], productId);
//        //  }
//           document.querySelector(`#size-chart-main-id-${productId} .tablinks`).classList.add('active');
//           document.querySelector(`#size-chart-main-id-${productId} .tabcontent`).classList.add('active');

         
//          sizeoverlay(productId)
//       })
//       .catch((error) => {
//        console.log('Error: ', error);
//      });
    
//   })
  
//   }sizeguide()


// function sizeoverlay(productId){
//     document.querySelector(".size-overlay").addEventListener("click", function(){
//         this.classList.remove("active");
//         document.querySelector(`#PopupModal-size-guide-${productId}`).removeAttribute('open');
//         body.classList.remove("hidescroll")
//     })
    
// }
  
  
  
   

//   function openCity(evt, cityName, productId) {
//     var parentModels = document.querySelectorAll("[id^='PopupModal-size-guide-']");
//     parentModels.forEach(parentModel => {
//     var tablinks = parentModel.querySelectorAll(".tablinks");
//     var tabcontent =  parentModel.querySelectorAll(".tabcontent");
//     tablinks.forEach((tablink,tabid)=>{
//         tablink.addEventListener("click", function(){
//             tabcontent.forEach((tabcontent,contentind)=>{
//                  if(tabid == contentind){
//                      tabcontent.classList.add("active")
//                  }else{
//                       tabcontent.classList.remove("active")
//                  }
//             })
//             tablinks.forEach(deskpar=>{
//                 deskpar.classList.remove("active");
//             })
//             tablink.classList.add("active");
//         })
//     })
   
//  });

// }


// function sizeclick(){
//      document.querySelectorAll('.cstmSize .product-popup-modal__button').forEach(sizeguidebtnclick=> {
//      sizeguidebtnclick.addEventListener("click",function(){
//            const ids = sizeguidebtnclick.getAttribute('pro-id');
//            document.querySelector(`#PopupModal-size-guide-${ids}`).setAttribute('open', '');
//            body.classList.add("hidescroll")
//            document.querySelector(".size-overlay").classList.add("active")
//      });
// });
// }
// sizeclick()


  // old size-cart-code-custom
  function sizeguide(){
    document.querySelectorAll('.cstmSize .product-popup-modal__button').forEach(sizeguidebtn => {
      sizeguidebtn.addEventListener("click",function(){
          const sizechartTags = sizeguidebtn.getAttribute('data-apne-product-tags');
          console.log(sizechartTags,"sizechartTags")
          const shopURL = sizeguidebtn.getAttribute('data-apna-shop-name');
          console.log(shopURL,"shopURL")
          const productId = sizeguidebtn.getAttribute('pro-id');
          const backend_url = 'https://sizechart-revamp-be.alche.cloud';
          const api_URL_sizeChart = '/ajax_call_sizechart?shop=' + shopURL + '&tags=';
          let sizeChart_url = backend_url + api_URL_sizeChart + sizechartTags.replace(/&/g, "&amp;");
          fetch(sizeChart_url)
         .then((response) => {
           return response.json()
         })
          .then((data) => {
               console.log(data,"data")
               let raw_html = ''
               const first_index_to_show = 0
               const size_attributes = {}
               var size_data ='';
               var sizes = new Array();
               var random = '';
               const topDes = data.size_chart.top_description
               console.log(topDes,"topDes")
               const { grid_sizechart } = data.size_chart
               const { sizechart_type } = data.size_chart
  
         grid_sizechart.forEach(attr => {
           const list = attr;
           const keyAttr = list.shift();
           size_attributes[keyAttr] = list;
         });
          raw_html += `<div title="${sizechart_type}" tag="${sizechart_type}" class="size-chart-content-wrapper">`
         raw_html += '<div class="size-chart-main-content">'
         raw_html += '<div class = "size-chart-content-data">'
         raw_html += '<div class="size-chart-title"><h2>Size help</h2><p class="size-chart-subheading">Select size</p></div>'
         
         raw_html += '<div class = "size-chart-content-show tab">'
         size_attributes['SIZE'].map((elem, index) =>{
           
           raw_html += `<div class="size-chart-size-variant tablinks ">${elem}</div>`
         })
         raw_html += '</div>'
         
         raw_html += '<div class="top-desc">' +topDes + '</div>'
         
         raw_html += '<div class="size-chart-head"><p class="head">MEASUREMENTS</p><p class="head right-align">CM</p><p class="head right-align">INCH</p></div>'
         size_attributes['SIZE'].map((elem, index) =>{
           raw_html += `<div id="${elem}" class="size-chart-table tabcontent"">`
           
           Object.keys(size_attributes).map(key =>{
   //           console.log("key",key)
             if (key == 'SIZE'){ return }
             const record = size_attributes[key]
             const cm_inch = Math.ceil(record[index]*0.393701);
             raw_html += '<div class="size-chart-size-data">'
             raw_html += `<div class="size-data-bold">${key}</div>`
             raw_html += `<div class="size-data-bold right-align">${record[index]}</div>`
             raw_html += `<div class="size-data-bold right-align">${cm_inch}</div>`
             raw_html += '</div>'	
             })
           raw_html += '</div>'
         })
         raw_html += '</div>'
         raw_html += `<div class="size-chart-content-img"><img class="image" src='${data.size_chart.bottom_description}' loading="lazy"></div>
         </div>
         <div class="size-note">Note: The size help refers to the product measurements which may slightly vary according to design.</div>
         </div>`
        document.querySelector(`#size-chart-main-id-${productId}`).innerHTML = raw_html;
         if (size_attributes && size_attributes['SIZE'] && size_attributes['SIZE'].length > 0) {
           openCity(undefined, size_attributes['SIZE'][first_index_to_show], productId);
         }
        document.querySelector(`#size-chart-main-id-${productId} .tablinks`).classList.add('active');
        document.querySelector(`#size-chart-main-id-${productId} .tabcontent`).classList.add('active');

         document.querySelector(`#PopupModal-size-guide-${productId}`).setAttribute('open', '');
         sizeoverlay(productId)
      })
      .catch((error) => {
       console.log('Error: ', error);
     });
     body.classList.add("hidescroll")
     document.querySelector(".size-overlay").classList.add("active")
  })
  })
   
  }
sizeguide()


function sizeoverlay(productId){
    document.querySelector(".size-overlay").addEventListener("click", function(){
        this.classList.remove("active");
        document.querySelector(`#PopupModal-size-guide-${productId}`).removeAttribute('open');
        body.classList.remove("hidescroll")
    })
    
}
  
  
  
   

  function openCity(evt, cityName, productId) {
    var parentModels = document.querySelectorAll("[id^='PopupModal-size-guide-']");
    parentModels.forEach(parentModel => {
    var tablinks = parentModel.querySelectorAll(".tablinks");
    var tabcontent =  parentModel.querySelectorAll(".tabcontent");
    tablinks.forEach((tablink,tabid)=>{
        tablink.addEventListener("click", function(){
            tabcontent.forEach((tabcontent,contentind)=>{
                 if(tabid == contentind){
                     tabcontent.classList.add("active")
                 }else{
                      tabcontent.classList.remove("active")
                 }
            })
            tablinks.forEach(deskpar=>{
                deskpar.classList.remove("active");
            })
            tablink.classList.add("active");
        })
    })
   
 });

}